import { render, staticRenderFns } from "./DoctorFlags.vue?vue&type=template&id=4bb8f1c2&"
import script from "./DoctorFlags.vue?vue&type=script&lang=js&"
export * from "./DoctorFlags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports